import { render, staticRenderFns } from "./BlocInfosTiers.vue?vue&type=template&id=86c91d68"
import script from "./BlocInfosTiers.vue?vue&type=script&lang=js"
export * from "./BlocInfosTiers.vue?vue&type=script&lang=js"
import style0 from "./BlocInfosTiers.vue?vue&type=style&index=0&id=86c91d68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports